import { STAGES } from './constants';
import { TECHNICIANS, INSURERS, SKU_TYPES } from './constants';

const MAKES = ['Toyota', 'Ford', 'Volkswagen', 'Nissan', 'Hyundai', 'BMW', 'Mercedes'];
const MODELS = {
  Toyota: ['Hilux', 'Corolla', 'Fortuner'],
  Ford: ['Ranger', 'EcoSport', 'Everest'],
  Volkswagen: ['Polo', 'Golf', 'Amarok'],
  Nissan: ['NP200', 'Navara', 'X-Trail'],
  Hyundai: ['i20', 'Tucson', 'Creta'],
  BMW: ['3 Series', 'X3', '1 Series'],
  Mercedes: ['C-Class', 'GLC', 'A-Class'],
};

// Revenue tiers by make (in Rand, inclusive ranges).
const REVENUE_TIERS = {
  Toyota: [1200, 3500],
  Ford: [1300, 3800],
  Volkswagen: [1400, 3900],
  Nissan: [1100, 3200],
  Hyundai: [1000, 3000],
  BMW: [3200, 6500],
  Mercedes: [3500, 6800],
};

const generateReg = () => {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const r = (str) => str[Math.floor(Math.random() * str.length)];
  return `${r(letters)}${r(letters)}${r(letters)} ${r(numbers)}${r(numbers)}${r(numbers)} GP`;
};

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const randIntInclusive = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const modelCode3 = (model) =>
  model.replace(/[^A-Za-z0-9]/g, '').slice(0, 3).toUpperCase();

const generateSku = (make, model) => {
  const type = pick(SKU_TYPES);
  const year = 2023 + Math.floor(Math.random() * 3); // 2023..2025
  return `GL-${type}-${modelCode3(model)}-${year}`;
};

const generateRevenue = (make) => {
  const [lo, hi] = REVENUE_TIERS[make];
  return Math.round(randIntInclusive(lo, hi) / 10) * 10; // rounded to R10
};

const generateInsurer = () => {
  // ~30% retail/null
  if (Math.random() < 0.3) return null;
  return pick(INSURERS.filter((i) => i !== 'Retail'));
};

export const generateMockVehicles = () => {
  const vehicles = [];
  const now = new Date();
  STAGES.forEach((stage) => {
    const count = Math.floor(Math.random() * 5) + 1;
    for (let i = 0; i < count; i++) {
      const make = MAKES[Math.floor(Math.random() * MAKES.length)];
      const model = MODELS[make][Math.floor(Math.random() * MODELS[make].length)];
      const stateRandomizer = Math.random();
      let minutesAgo;
      if (stateRandomizer > 0.8) {
        minutesAgo = stage.slaMinutes + Math.floor(Math.random() * 30) + 5;
      } else if (stateRandomizer > 0.5) {
        minutesAgo = Math.floor(stage.slaMinutes * 0.85);
      } else {
        minutesAgo = Math.floor(stage.slaMinutes * 0.3);
      }
      const customerWait = Math.random() > 0.7;
      vehicles.push({
        id: `veh-${Math.random().toString(36).substr(2, 9)}`,
        regNumber: generateReg(),
        make,
        model,
        stageId: stage.id,
        entryTime: new Date(now.getTime() - minutesAgo * 60000).toISOString(),
        customerWait,
        customerWaitMins: customerWait ? randIntInclusive(5, 45) : 0,
        revenue: generateRevenue(make),
        sku: generateSku(make, model),
        technician: pick(TECHNICIANS),
        insurer: generateInsurer(),
        promiseTimeMins: randIntInclusive(60, 240),
      });
    }
  });
  return vehicles;
};
